/** Plotly figure JSON from the API (sat_core.charts) rendered with the basic bundle. */
import Plotly from "plotly.js-basic-dist-min";
import createPlotlyComponent from "react-plotly.js/factory";

import { Spinner } from "./ui";

const Plot = createPlotlyComponent(Plotly);

export function Chart({ figure, loading, error, height }: { figure?: { data: any[]; layout: Record<string, any> }; loading?: boolean; error?: unknown; height?: number }) {
  if (loading) return <div className="chart-box"><Spinner label="Drawing chart" /></div>;
  if (error || !figure) return null;
  const layout = { ...figure.layout, autosize: true, ...(height ? { height } : {}), font: { family: "IBM Plex Sans, sans-serif" } };
  return (
    <div className="chart-box">
      <Plot
        data={figure.data}
        layout={layout}
        config={{ displaylogo: false, responsive: true, modeBarButtonsToRemove: ["lasso2d", "select2d"] }}
        style={{ width: "100%" }}
        useResizeHandler
      />
    </div>
  );
}
